import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Logo } from '../../../web/src/components/navigation/logo.jsx';
import { Link } from '../../../web/src/components/navigation/link.jsx';
import { LanguageToggle } from './language-toggle.jsx';
import { APP_URL } from '../app-config.js';

/**
 * Sticky marketing-site header: brand, nav links, language toggle, and the
 * go-to-app CTA.
 * @returns {JSX.Element}
 */
export function SiteHeader() {
	const { lang } = useParams();
	const { t } = useTranslation();
	return (
		<header className="site-header">
			<Link to={`/${lang}/`} className="site-brand" aria-label="Thyme">
				<Logo size={26} className="site-brand-logo" />
				<span className="site-brand-name">Thyme</span>
			</Link>
			<nav className="site-nav" aria-label={t('site.nav.label')}>
				<Link to={`/${lang}/`} className="site-nav-link">{t('site.nav.home')}</Link>
				<Link to={`/${lang}/story/`} className="site-nav-link">{t('site.nav.story')}</Link>
				<Link to={`/${lang}/use-cases/`} className="site-nav-link">{t('site.nav.useCases')}</Link>
				<Link to={`/${lang}/pricing/`} className="site-nav-link">{t('site.nav.pricing')}</Link>
			</nav>
			<div className="site-header-actions">
				<LanguageToggle />
				<a className="btn btn-primary btn-sm" href={APP_URL} target="_blank" rel="noreferrer">{t('site.nav.goToApp')}</a>
			</div>
		</header>
	);
}
